import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './../../firebaseConfig'; // Firebase auth instance
import Input from './../ui/Input';
import Button from './../ui/Button';
import './RessetPassword.css';

interface ResetPasswordProps {
  onSwitch: () => void;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ onSwitch }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess('Password reset email sent. Please check your inbox.');
      console.log('Password reset email sent to:', email);
    } catch (err: any) {
      setError('Failed to send reset email. ' + err.message);
      console.error('Error sending reset email:', err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <h2 className="reset-title">Reset Password</h2>
      <p className="reset-subtext">
        Enter your email address to reset your password.
      </p>
      <form onSubmit={handleReset} className="reset-form">
        <Input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        <Button type="submit" width="100%" disabled={loading}>
          {loading ? 'Sending...' : 'Reset Password'}
        </Button>
      </form>
      <p className="back-to-login">
        Remember your password?{' '}
        <span onClick={onSwitch} className="link">
          Login
        </span>
      </p>
    </div>
  );
};

export default ResetPassword;
